import availableJobCategories from '@/helpers/availableJobCategoriesHelper'
import availableLanguages from '@/helpers/availableLanguagesHelper'

export default function () {
    return {
        availableJobCategories,
        availableLanguages,
        availableCities: [],
        citySearchInput: null,
        loadingCities: false,
        cityDebounceTimeout: null,
        cityRequestId: 0,
        reachedEnd: false,
        filters: {
            'user.id[not]': [],
            'user.address.city': null,
            ethnicity: null,
            hairColor: null,
            'height[gte]': null,
            'fees.type': null,
            'user.gender': null,
            'user.name': null,
            'user.phone': null,
            'inArray[user.languages]': [],
            favoritesFirst: false,
            'user.symplaParticipations.event.id': [],
            'user.symplaParticipations.profiles': null
        },
        availableFilters: {
            casting: [
                'ethnicity',
                'hairColor',
                'height',
                'fees',
                'gender',
                'ethnicity',
                'city',
                'languages'
            ],
            'event_support': [
                'ethnicity',
                'hairColor',
                'height',
                'fees',
                'gender',
                'ethnicity',
                'city',
                'languages'
            ],
            'bars_restaurants': [
                'ethnicity',
                'hairColor',
                'height',
                'fees',
                'gender',
                'ethnicity',
                'city',
                'languages'
            ],
            'master_of_ceremonies': [
                'ethnicity',
                'hairColor',
                'height',
                'fees',
                'gender',
                'ethnicity',
                'city',
                'languages'
            ],
        },
        showVaccinationCertificateFilter: false,
        filterVaccinationCertificate: false,
        profiles: [],
        currentProfileIndex: 0,
        showNoProfilesFound: false,
        showSymplaEvents: true,
        symplaEvents: [],
        showCoursesDescription: false,
        nameFilterDebounceTimeout: null
    }
}
